import React from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

function AdminLayout({ children }) {
  return (
    <>
      <Header />

      <div style={{ minHeight: "80vh", padding: "20px" }}>
        {children}
      </div>

      <Footer />
    </>
  );
}

export default AdminLayout;
